<div class="chart-volume">
    <span class="chart-label">{{ label }}</span>
    <span class="chart-value">{{ value | number }}</span>
</div>
<div class="chart-bar">
    <span [style.width.%]="value * 100 / maxValue"></span>
</div>
